import { CSSProperties } from 'react';
import { AdminHeaderView } from '../header/admin-header.view';
import { AdminHeaderTitleView } from '../header/admin-header-title.view';
import { ExportCsvButtonView } from '../../buttons';

const headerStyle: CSSProperties = { margin: '20px 0 0 20px' };

const titleStyle: CSSProperties = { display: 'flex', flexDirection: 'column' };

const customHeaderStyle: CSSProperties = { boxShadow: 'none', marginRight: '50px', marginLeft: '50px' };

const exportButtonStyle: CSSProperties = { right: '10px', height: 'initial' };

interface PageSubHeaderViewProps {
    title?: string;
    customHeader?: React.ReactNode;
    exportToCsv?: () => void;
}

export const PageSubHeaderView = ({ title, customHeader, exportToCsv }: PageSubHeaderViewProps) => {
    return (
        <AdminHeaderView style={headerStyle}>
            {title && (
                <div style={titleStyle}>
                    <AdminHeaderTitleView title={title} />
                </div>
            )}
            {customHeader && <div style={customHeaderStyle}>{customHeader}</div>}

            {exportToCsv && <ExportCsvButtonView onClick={exportToCsv} style={exportButtonStyle} />}
        </AdminHeaderView>
    );
};
